export interface FAQItem {
  question: string;
  answer: string;
}

export interface ReviewItem {
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export interface BrandInfo {
  name: string;
  slogan: string;
  description: string;
  founded: string;
  mission: string;
  vision: string;
  values: string[];
  stats: { label: string; value: string }[];
  address: string;
  email: string;
  phone: string;
  wechat: string;
  businessHours: string;
}

export const brandInfo: BrandInfo = {
  name: '黄瓜影视',
  slogan: '免费高清影视全集，随时随地畅享观影体验',
  description: '黄瓜影视是一家专注于在线视频播放的互联网平台，成立于2020年。我们致力于为广大影视爱好者提供海量优质的高清影视内容，涵盖电影、电视剧、综艺、动漫等全类型内容。用户无需下载任何客户端，打开浏览器即可流畅观看高清视频。',
  founded: '2020年',
  mission: '让每一个人都能免费享受高质量的影视内容，消除观影门槛，让好内容触手可及。',
  vision: '成为华语地区最受欢迎的免费高清影视平台，用技术和内容连接每一位影视爱好者。',
  values: ['用户至上', '内容为王', '技术创新', '诚信正直', '开放共享'],
  stats: [
    { label: '影视资源', value: '10万+' },
    { label: '日活用户', value: '500万+' },
    { label: '累计播放', value: '50亿+' },
    { label: '合作版权方', value: '200+' },
  ],
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  email: 'contact@huanggua.tv',
  phone: '400-888-6666',
  wechat: 'huanggua_movie',
  businessHours: '周一至周日 9:00 - 21:00',
};

export const faqs: FAQItem[] = [
  {
    question: '黄瓜影视是否需要注册才能观看？',
    answer: '不需要！黄瓜影视完全免费，无需注册即可观看所有内容。我们致力于提供无障碍的观影体验，让每一位用户都能轻松享受高清影视。',
  },
  {
    question: '黄瓜影视支持哪些设备观看？',
    answer: '黄瓜影视支持所有主流设备，包括电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）、智能电视等。只需打开浏览器访问我们的网站即可开始观看。',
  },
  {
    question: '影片的画质如何？是否支持高清播放？',
    answer: '我们提供多种画质选择，包括流畅、标清、高清和超清（1080P）。大部分热门内容都支持高清及以上画质，用户可根据自己的网络状况自由切换。',
  },
  {
    question: '黄瓜影视的影片资源多久更新一次？',
    answer: '我们的内容团队每天都会更新视频资源。热门电影会在院线下映后第一时间上线，热门电视剧和综艺会在播出后24小时内更新，确保用户能够及时观看到最新内容。',
  },
  {
    question: '观看时出现卡顿怎么办？',
    answer: '如果遇到卡顿情况，建议尝试以下方法：1) 切换较低画质；2) 检查网络连接是否稳定；3) 关闭其他占用带宽的应用；4) 刷新页面重新加载。如仍无法解决，可联系我们的客服获取帮助。',
  },
  {
    question: '黄瓜影视的影片来源是否合法？',
    answer: '黄瓜影视严格遵守相关法律法规，所有影片内容均来自正版授权合作方。我们与多家影视版权方建立了长期合作关系，确保平台上的所有内容都有合法授权，用户可以放心观看。',
  },
];

export const reviews: ReviewItem[] = [
  {
    name: '王小明',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20professional%20portrait%20photo%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20casual%20style%2C%20warm%20natural%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '黄瓜影视真的太棒了！资源超级丰富，几乎想看的电影电视剧都能找到。画质清晰，播放流畅，完全不卡顿。最重要的是完全免费，太良心了！',
    date: '2025-01-20',
  },
  {
    name: '李雪儿',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20professional%20portrait%20photo%2C%20warm%20smile%2C%20clean%20light%20background%2C%20elegant%20style%2C%20soft%20natural%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为一个追剧狂魔，黄瓜影视简直就是我的快乐源泉！更新速度超快，热门剧集基本同步更新。分类也很清晰，找剧特别方便。强烈推荐！',
    date: '2025-01-18',
  },
  {
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20man%20professional%20portrait%20photo%2C%20confident%20expression%2C%20clean%20background%2C%20business%20casual%20style%2C%20natural%20studio%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '用黄瓜影视已经两年多了，见证了它从一个小网站发展到现在这么大的平台。资源越来越多，体验越来越好。支持多设备观看，通勤路上用手机看，回家用电视投屏，非常方便。',
    date: '2025-01-15',
  },
  {
    name: '赵敏儿',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20photo%20with%20glasses%2C%20intellectual%20look%2C%20clean%20white%20background%2C%20modern%20style%2C%20soft%20bright%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '朋友推荐的黄瓜影视，用了一次就爱上了。界面简洁清爽，没有乱七八糟的广告弹窗。内容质量也很高，很多经典老片都能找到，怀旧党的福音！希望能继续坚持下去。',
    date: '2025-01-12',
  },
  {
    name: '陈大力',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20professional%20headshot%20portrait%20photo%2C%20friendly%20casual%20look%2C%20clean%20light%20gray%20background%2C%20modern%20style%2C%20natural%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '市面上很多影视网站要么收费要么全是广告，黄瓜影视真的是业界的清流。不仅免费，而且内容品质一点不输付费平台。推荐给了身边所有朋友，大家都说好用！',
    date: '2025-01-08',
  },
  {
    name: '刘小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20photo%20with%20long%20hair%2C%20cheerful%20smile%2C%20clean%20bright%20background%2C%20casual%20style%2C%20warm%20natural%20lighting%2C%20simple%20composition&width=100&height=100&seq=avatar-06&orientation=squarish',
    rating: 5,
    content: '黄瓜影视的分类功能做得特别好，电影、电视剧、综艺、动漫分得很清楚，搜剧也很方便。最近更新的庆余年第二季画质超棒，看得太过瘾了！黄瓜影视yyds！',
    date: '2025-01-05',
  },
];